/** @type {import("@mui/material").SxProps<Theme>} */

import theme from '../../theme/theme';

const styles = {
  mainNavStyle: {
    mainNavs: {
      // p: "8px 32px",
      display: 'flex',
      cursor: 'pointer',

      color: theme.palette.secondary.mobileActiveToggleBackground,
      '& .MuiSvgIcon-root.dropdownIcon': {
        color: 'transparent',
      },
      '&:hover': {
        '& .MuiSvgIcon-root.dropdownIcon': {
          color: theme.palette.secondary.mobileActiveToggleBackground,
        },
      },
      alignItems: 'center',
    },
    dropdownContainer: {
      position: 'absolute',
      top: 113,
      left: '0',
      right: '0',
      zIndex: 5,
      bgcolor: theme.palette.primary.contrastText,
    },
    gridContainer: {},
    navLinkTitle: {
      py: 2,
      px: 1,
      cursor: 'text',
    },
    navLinks: {
      color: theme.palette.primary.textColor3,
      textDecoration: 'none',
      paddingTop: 1,
      paddingBottom: 1,
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
    navIcon: {
      ml: 1,
      fontSize: '2rem',
    },
    cartIcon: {
      p: 1,
      color: theme.palette.secondary.mobileActiveToggleBackground,
      fontSize: theme.typography.body3.fontSize,
      display: 'contents',
      cursor: 'pointer',
    },
  },
  collapseContainer: {
    container: {
      borderBottom: 0,
      color: theme.palette.primary.textColor3,
      // mb: 0.5,
      bgcolor: 'transparent',
      boxShadow: 'none',
      borderRadius: 0,
      '& .MuiAccordionSummary-root': {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        '& .MuiAccordionSummary-content': {
          flexGrow: '0',
        },
      },
      '&:before': {
        backgroundColor: 'transparent',
      },
    },
    details: {
      borderBottom: 'none',
      // mb: 1,
      bgcolor: 'transparent',
      boxShadow: 'none',
      borderRadius: 0,
      // fontFamily: 'eir-bold',
      // fontWeight: 'inherit',
      // fontSize: '1.25rem',
      // lineHeight: 1.6,
    },
    summary: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      fontFamily: theme.typography.h5.fontFamily,
      fontWeight: theme.typography.h5.fontWeight,
      fontSize: theme.typography.h5.fontSize,
      lineHeight: theme.typography.h5.lineHeight,
      // padding: '0.5rem 1 rem',
    },
  },
  subNavLinks: {
    p: '8px 16px',
    color: theme.palette.primary.contrastText,
  },
  subCollapseContainer: {
    container: {
      borderBottom: 0,
      // mb: 0.5,
      bgcolor: 'transparent',
      boxShadow: 'none',
      borderRadius: 0,
      '& .MuiAccordionSummary-root': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& .MuiAccordionSummary-content': {
          flexGrow: '0',
        },
      },
      '&:before': {
        backgroundColor: 'transparent',
      },
    },
    details: {
      borderBottom: 0,
      // mb: 0.5,
      bgcolor: 'transparent',
      boxShadow: 'none',
      borderRadius: 0,
      '& .MuiAccordionSummary-root': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& .MuiAccordionSummary-content': {
          flexGrow: '0',
        },
      },
      '&:before': {
        backgroundColor: 'transparent',
      },
    },
    // details: {
    //   borderBottom: 0,
    //   // mb: 0.5,
    //   bgcolor: 'transparent',
    //   boxShadow: 'none',
    //   borderRadius: 0,
    // },
    summary: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      fontFamily: theme.typography.h6.fontFamily,
      fontWeight: theme.typography.h6.fontWeight,
      fontSize: theme.typography.h6.fontSize,
      lineHeight: theme.typography.h6.lineHeight,
    },
    // summary: {
    //   display: 'flex',
    //   justifyContent: 'flex-start',
    //   alignItems: 'center',
    //   fontFamily: 'eir-bold',
    //   fontWeight: 'inherit',
    //   fontSize: '0.9rem',
    //   lineHeight: 1.6,
    // },
  },
  navTitle: {
    fontFamily: theme.typography.h5.fontFamily,
    fontWeight: theme.typography.h5.fontWeight,
    fontSize: theme.typography.h5.fontSize,
    lineHeight: theme.typography.h5.lineHeight,
    color: theme.palette.primary.textColor3,
    mobileView: {
      fontSize: '1.069rem',
      lineHeight: '1.75rem',
    },
  },
  solidctastyle: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    // width: '212px',
    // padding: '0.3125rem',
    padding: '8px 22px',
    margin: '16px 0 9px 0',
    // height: '40px',

    color: theme.palette.secondary.contrastText,
    background: theme.palette.primary.buttonColor,
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 4px 45px -9px ${theme.palette.primary.boxShadow1Darkest}`,
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '0.5rem',
    },
    // Hidden visually until focused
    position: 'absolute',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    //  width: 1,
    //  height: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',

    '&:focus-visible': {
      position: 'static',
      clip: 'auto',
      clipPath: 'none',
      width: 'auto',
      height: 'auto',
      //  padding: '8px 12px',
      outline: '3px solid #DD1D78',
      outlineOffset: '3px',
      //  mb: 1,
    },
  },
};

export default styles;
